import { createAction, props } from '@ngrx/store';

// Interfaces
import { ICardItem, ICards } from '@interfaces/stripe-card.interface';

export const clearPaymentCards = createAction('[Payments] Clear payments cards');

export const loadPaymentCards = createAction('[Payments] Load payments cards');

export const loadPaymentCardsSuccess = createAction(
  '[Payments] Load payments cards success',
  props<{ cards: ICards }>(),
);

export const loadPaymentCardsError = createAction(
  '[Payments] Load payments cards error',
  props<{ error: unknown }>(),
);

export const addNewCard = createAction('[Payments] Add new card', props<{ card: ICardItem }>());

export const updateSelectedCard = createAction(
  '[Payments] Update selected card',
  props<{ cardId: string }>(),
);

export const deleteCard = createAction('[Payments] Delete card', props<{ cardId: string }>());

export const deleteCardSuccess = createAction(
  '[Payments] Delete card success',
  props<{ cardId: string }>(),
);

export const deleteCardError = createAction(
  '[Payments] Delete card error',
  props<{ error: unknown }>(),
);
